import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=5391d79e&scoped=true"
import script from "./Analysis.vue?vue&type=script&lang=js"
export * from "./Analysis.vue?vue&type=script&lang=js"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=5391d79e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391d79e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5391d79e')) {
      api.createRecord('5391d79e', component.options)
    } else {
      api.reload('5391d79e', component.options)
    }
    module.hot.accept("./Analysis.vue?vue&type=template&id=5391d79e&scoped=true", function () {
      api.rerender('5391d79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Analysis.vue"
export default component.exports